<template>
    <modal name="investor_risk_setting_modal" :scrollable="true" height="auto" :width="this.modalWidth" style="z-index:1200;">
        <div class="modal-content">
            <div class="modal-header pt-3 pr-0">
                <div class="col-md-12 pr-3">
                    <i v-on:click="close" class="fa fa-times-circle pull-right" style="color:#000; cursor:pointer;"></i>
                </div>
            </div>
            <div class="modal-body" style="padding: 5px 20px !important">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <h3 class="mb-0 pull-left"><b>Investment Experience</b></h3>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-3">
                            <div class="form-group mb-3">
                                <label>Have you previously invested using a P2P platform? *</label>
                                <div class="radio-inline mt-0">
                                    <div class="checkbox-radios">
                                        <div class="form-check form-check-radio mt-0">
                                            <label class="form-check-label" dusk="check-invested-p2p-yes">
                                                <input class="form-check-input" type="radio" v-model="form.invested_in_p2p" name="invested_in_p2p" value="1">
                                                <span class="form-check-sign"></span>
                                                Yes
                                            </label>
                                        </div>
                                        <div class="form-check form-check-radio" dusk="check-invested-p2p-no">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" v-model="form.invested_in_p2p" name="invested_in_p2p" value="0">
                                                <span class="form-check-sign"></span>
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mb-3" v-if="parseInt(form.invested_in_p2p) === 1" :class="{' has-danger' : $v.form.inv_estimated_p2p_invested.$error}">
                                <label>Please enter an estimated amount of P2P Investment</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text" style="height: min-content; font-size: 0.8em">
                                            RM
                                        </div>
                                    </div>
                                    <input type="number"
                                            @blur="$v.form.inv_estimated_p2p_invested.$touch()"
                                            v-model="form.inv_estimated_p2p_invested"
                                            class="form-control mb-2"
                                            name="p2p_amount"/>
                                </div>
                                <div v-if="$v.form.inv_estimated_p2p_invested.$error" dusk="estimate_p2p_error">
                                    <div class="small text-danger" v-if="!$v.form.inv_estimated_p2p_invested.required">
                                        Estimated amount of P2P Investment is required
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mb-3" :class="{' has-danger' : $v.form.inv_risk_tolerance.$error}">
                                <label>What's your Risk Tolerance Level? *</label>
                                <div class="checkbox-radios">
                                    <div class="form-check form-check-radio mt-0">
                                        <label class="form-check-label" dusk="check-conservative">
                                            <input class="form-check-input" type="radio"
                                                    @change="$v.form.inv_risk_tolerance.$touch()"
                                                    v-model="form.inv_risk_tolerance" name="risk_tolerance" value="conservative">
                                            <span class="form-check-sign"></span>
                                            <b>Conservative</b>
                                            <p>
                                                I usually invest in lower-risk assets, such as fixed-income and money market securities, and often blue-chip or large-cap equities.
                                            </p>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-radio">
                                        <label class="form-check-label" dusk="check-balance">
                                            <input class="form-check-input" type="radio"
                                                    @change="$v.form.inv_risk_tolerance.$touch()"
                                                    v-model="form.inv_risk_tolerance"  name="risk_tolerance" value="balanced">
                                            <span class="form-check-sign"></span>
                                            <b>Balanced</b>
                                            <p>I am willing to accept periods of moderate market volatility in exchange for the possibility of receiving returns that outpace inflation by a significant margin through investing in a balanced portfolio of equities and fixed-income.</p>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-radio">
                                        <label class="form-check-label" dusk="check-aggressive">
                                            <input class="form-check-input" type="radio"
                                                    @change="$v.form.inv_risk_tolerance.$touch()"
                                                    v-model="form.inv_risk_tolerance" name="risk_tolerance" value="aggressive">
                                            <span class="form-check-sign"></span>
                                            <b>Aggressive</b>
                                            <p>
                                                I am open to risk and am willing to see large short-term swings in market performance on an annualised basis in exchange for returns. I invest predominantly in equities.
                                            </p>
                                        </label>
                                    </div>
                                </div>

                                <div v-if="$v.form.inv_risk_tolerance.$error" dusk="risk_tolerance_error">
                                    <div class="small text-danger" v-if="!$v.form.inv_risk_tolerance.required">
                                        Please select a Risk Tolerance Level
                                    </div>
                                </div>
                            </div>

                            <!-- years of exp-->
                            <div class="form-group">
                                <label>Your years of experience in (any) of the below </label>
                                <div class="alert alert-info">
                                    1 - I don't know about this product <br/>
                                    2 - I understand this product but have not invested in it <br/>
                                    3 - 1-3 years experience investing in this product <br/>
                                    4 - Professional investor or >3 years experience investing <br/>
                                </div>

                            </div>
                            
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="d-block">Stock / equities, other financial products (if any)<span class="badge badge-pill badge-info float-right" v-if="form.inv_stocks_knowledge_years">{{ form.inv_stocks_knowledge_years }} </span></label>
                                        <input type="range" min="1" max="4" value="1" class="slider form-control"  v-model="form.inv_stocks_knowledge_years">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="d-block">Bonds, Private Debt Securities, SME Notes <span class="badge badge-pill badge-info float-right" v-if="form.inv_bonds_knowledge_years">{{ form.inv_bonds_knowledge_years }} </span></label>
                                        <input type="range" min="1" max="4" value="1" class="slider form-control" v-model="form.inv_bonds_knowledge_years"/>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="d-block">Mutual Funds <span class="badge badge-pill badge-info float-right" v-if="form.inv_mutual_funds_knowledge_years">{{ form.inv_mutual_funds_knowledge_years }} </span></label>
                                        <input type="range" min="1" max="4" value="1" class="slider form-control" v-model="form.inv_mutual_funds_knowledge_years"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="d-block">Others (e.g. commodities, derivatives, currencies, crypto etc) <span class="badge badge-pill badge-info float-right" v-if="form.inv_others_knowledge_years">{{ form.inv_others_knowledge_years }} </span></label>
                                        <input type="range" min="1" max="4" value="1" class="slider form-control"  v-model="form.inv_others_knowledge_years"/>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="d-block">P2P Lending <span class="badge badge-pill badge-info float-right" v-if="form.inv_p2p_lending_knowledge_years">{{ form.inv_p2p_lending_knowledge_years }} </span></label>
                                        <input type="range" ref="p2p_leading_experience" min="1" max="4" value="1" class="slider form-control"
                                                v-model="form.inv_p2p_lending_knowledge_years"
                                                :disabled="form.invested_in_p2p == 0"/>

                                        <p class="small text-muted" v-show="form.invested_in_p2p == 0">Not required if no existing exposure in P2P</p>
                                    </div>
                                </div>
                            </div>
                            <!--/years of exp-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer row" style="padding-bottom: 25px;">
                <div class="col-md-12 d-flex flex-row justify-content-center">
                    <a href="#" v-on:click.prevent="updateRiskProfile" class="btn btn-block btn-success">Update</a>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import UserService from "../../services/UserService";
export default {
    name: 'InvestorRiskSettingModal',
    props: {
        // 
    },
    data () {
        return {
            form: {
                invested_in_p2p: 0,
                inv_estimated_p2p_invested: 0,
                inv_risk_tolerance: null,
                inv_stocks_knowledge_years: 1,
                inv_bonds_knowledge_years: 1,
                inv_mutual_funds_knowledge_years: 1,
                inv_others_knowledge_years: 1,
                inv_p2p_lending_knowledge_years: 1,
            },
            modalWidth: 400,
        }
    },
    created () {

        if (document.documentElement.clientWidth < 700) {
          this.modalWidth = 350;
        } else {
          this.modalWidth = 700;
        }

        window.addEventListener("resize", () => {
          if (document.documentElement.clientWidth < 700) {
            this.modalWidth = 350;
          } else {
            this.modalWidth = 700;
          }
        });

        UserService.getInvestorRiskSettings().then((res) => {
            if (res.data.success) {
                if (res.data.inv_estimated_p2p_invested){
                    this.form.inv_estimated_p2p_invested = parseInt(res.data.inv_estimated_p2p_invested);

                    if (parseInt(res.data.inv_estimated_p2p_invested) > 0)
                    {
                        this.form.invested_in_p2p = 1
                    } else
                    {
                        this.form.invested_in_p2p = 0
                    }
                }

                if (res.data.inv_risk_tolerance){
                    this.form.inv_risk_tolerance = (res.data.inv_risk_tolerance).toLowerCase();
                }

                if (res.data.inv_stocks_knowledge_years){
                    this.form.inv_stocks_knowledge_years = parseInt(res.data.inv_stocks_knowledge_years);
                }
                if (res.data.inv_bonds_knowledge_years){
                    this.form.inv_bonds_knowledge_years = parseInt(res.data.inv_bonds_knowledge_years);
                }
                if (res.data.inv_mutual_funds_knowledge_years){
                    this.form.inv_mutual_funds_knowledge_years = parseInt(res.data.inv_mutual_funds_knowledge_years);
                }
                if (res.data.inv_others_knowledge_years){
                    this.form.inv_others_knowledge_years = parseInt(res.data.inv_others_knowledge_years);
                }
                if (res.data.inv_p2p_lending_knowledge_years){
                    this.form.inv_p2p_lending_knowledge_years = parseInt(res.data.inv_p2p_lending_knowledge_years);
                }
            }
        })
    },
    mounted () {
        //
    },
    validations () {
        return {
            form: {
                inv_risk_tolerance: { required },
                inv_estimated_p2p_invested: { required: requiredIf((form) => {
                        return parseInt(form.invested_in_p2p) === 1
                    })
                },
                
            },
        }
    },

    watch: {
        form : {
            deep: true,
            handler() {
                //
            },
        }
    },

    computed : {
        //
    },

    methods : {
        open () {
            this.$modal.show('investor_risk_setting_modal');
        },
        close () {
            this.$modal.hide('investor_risk_setting_modal');
        },

        updateRiskProfile () {
            this.$v.form.$touch()

            if(this.$v.form.$invalid) {
                return true
            }

            if (this.form.invested_in_p2p == 0)
            {
                this.form.inv_estimated_p2p_invested = 0
            }

            if (this.form.invested_in_p2p == 0)
            {
                this.form.inv_p2p_lending_knowledge_years = 1
            }

            UserService.updateInvestorRiskSettings(this.form)
                .then((res) => {
                    if (res.data.success) {
                        this.$noty.success('Successfully updated');
                        this.close()
                    }
                })
                .catch((err) => {
                    this.$noty.error('Unable to update, try again later.');
                });
        },
    }
}
</script>

<style>

</style>
